import React, { useEffect, useState } from "react";
import client, { formatApiError } from "@/lib/api";
import SchoolAnalyticsView from "@/components/SchoolAnalyticsView";

/**
 * A principal's "Progress" tab: the shared SchoolAnalyticsView for her own school (verdict, the numbers that matter, then classes &
 * teachers, students who need help, activity over time and the downloadable report). The per-class cards that used to sit below it
 * are the "Classes & teachers" tab now, so nothing is shown twice.
 */
export default function PrincipalProgress() {
  const [schoolId, setSchoolId] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    client.get("/principal/overview")
      .then(({ data }) => setSchoolId(data?.school?.id || null))
      .catch((ex) => setErr(formatApiError(ex.response?.data?.detail) || ex.message));
  }, []);

  return (
    <div data-testid="principal-progress">
      <h2 className="hv-heading text-2xl text-hv-navy">School Progress</h2>
      <p className="text-hv-slate text-sm mt-1">How your students are doing — today, and over time.</p>

      {err && <div className="mt-4 hv-card p-4 text-hv-coral font-bold text-sm" data-testid="principal-progress-error">{err}</div>}

      <div className="mt-6">
        <SchoolAnalyticsView schoolId={schoolId} />
      </div>
    </div>
  );
}
